import { Cart } from "./cart.js";
import { loadCategories } from "./data.js";
import { renderCategories, updateCartBadge } from "./render.js";
import { closeEurPopup, openEurPopup, setExchangeConfig, showReceipt } from "./receipt.js";
import { setupBarPopup, openBarPopup } from "./bar.js";
import { injectAppShell } from "./template.js";
import type { AppConfig } from "./types.js";

declare const bootstrap: typeof import('bootstrap');

const config: AppConfig = (window as { APP_CONFIG?: AppConfig }).APP_CONFIG ?? { dataPath: "data/data.json" };
const cart = new Cart(`spc-rechner-cart-${location.pathname.replace(/^\/|\/$/g, "").replace(/\//g, "-") || "default"}`);

document.addEventListener("DOMContentLoaded", () => {
    injectAppShell();
    cart.load();
    updateCartBadge(cart);

    loadCategories(config.dataPath)
        .then(({ categories, title, label, showTwint, showCash, exchange, twintQr }) => {
            renderCategories(categories, cart, `spc-rechner-cat-${label.toLowerCase()}`);
            document.title = title;
            document.getElementById("page-title")!.textContent = title;
            if (!showTwint) document.getElementById("btn-twint")!.classList.add("d-none");
            if (!showCash) document.getElementById("btn-bar")!.classList.add("d-none");
            if (!exchange.show) document.getElementById("btn-eur")!.classList.add("d-none");
            setExchangeConfig(exchange);
            if (twintQr) (document.getElementById("twint-qr") as HTMLImageElement).src = twintQr;
            fadeOverlay();
        })
        .catch((err: unknown) => {
            console.error("Error loading data:", err);
            document.getElementById("items")!.innerHTML =
                `<div class="alert alert-danger m-3">Fehler beim Laden der Daten. Bitte Seite neu laden.</div>`;
            fadeOverlay();
        });

    document.getElementById("btn-calculate")!.addEventListener("click", () => showReceipt(cart));

    document.getElementById("btn-reset")!.addEventListener("click", () => {
        if (confirm("Warenkorb wirklich zur\u00fccksetzen?")) {
            cart.reset();
            updateCartBadge(cart);
            bootstrap.Modal.getInstance(document.getElementById("receiptModal")!)?.hide();
        }
    });

    const twintPopup = document.getElementById("twintPopup")!;
    const closeTwint = () => twintPopup.classList.add("d-none");
    document.getElementById("btn-twint")!.addEventListener("click", () => twintPopup.classList.remove("d-none"));
    document.getElementById("twintPopupClose")!.addEventListener("click", closeTwint);
    document.getElementById("twintPopupBackdrop")!.addEventListener("click", closeTwint);

    const eurPopup = document.getElementById("eurPopup")!;
    const closeEur = () => closeEurPopup();
    document.getElementById("btn-eur")!.addEventListener("click", () => openEurPopup(cart));
    document.getElementById("eurPopupClose")!.addEventListener("click", closeEur);
    document.getElementById("eurPopupBackdrop")!.addEventListener("click", closeEur);

    const barPopup = document.getElementById("barPopup")!;
    const closeBar = () => barPopup.classList.add("d-none");
    document.getElementById("btn-bar")!.addEventListener("click", () => openBarPopup(cart));
    document.getElementById("barPopupClose")!.addEventListener("click", closeBar);
    document.getElementById("barPopupBackdrop")!.addEventListener("click", closeBar);

    setupBarPopup();
});

function fadeOverlay(): void {
    const overlay = document.getElementById("page-black-overlay");
    if (!overlay) return;
    overlay.classList.add("fade-out");
    setTimeout(() => { overlay.style.display = "none"; }, 300);
}